import { Component, Injector, OnDestroy, OnInit } from "@angular/core";
import { TipoPagamentoEcgTerceiroService } from "../../contratacao/operacao/tipo-pagamento-ecg-terceiro.service";
import { TipoPagamentoEcgTerceiro } from "src/app/model/tipo-pagamento-ecg-terceiro";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { LimitePagamentoEcgTerceiro } from "src/app/model/limite-pagamento-ecg-terceiro";
import { BaseEntityComponent, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import {
  EntradaLimitePagamentoEcgTerceiro,
  LimitePagamentoEcgTerceiroService,
} from "../limite-pagamento-ecg-terceiro.service";
import { takeUntil } from "rxjs/operators";
import moment from "moment";
import { DataSistemaService } from "src/app/shared/services/data-sistema.service";
import { OcorrenciaValidacaoVO } from "src/app/shared/ocorrencia-validacao.vo";
import {BnAlertsService} from '@bndes/bndes-ux4/bn-alerts';

@Component({
  selector: "app-limite-pagamento-ecg-por-terceiros-cadastro",
  templateUrl: "./limite-pagamento-ecg-por-terceiros-cadastro.component.html",
  styleUrls: ["./limite-pagamento-ecg-por-terceiros-cadastro.component.scss"],
  standalone: false
})
export class LimitePagamentoEcgPorTerceirosCadastroComponent
  extends BaseEntityComponent<LimitePagamentoEcgTerceiro>
  implements OnInit, OnDestroy
{
  private readonly destroy$: Subject<any> = new Subject();

  modoEdicao: boolean = false;
  tipos: TipoPagamentoEcgTerceiro[] = [];
  ideTipoSelecionado: number = null;
  limiteFundoPrevio?: LimitePagamentoEcgTerceiro = null;
  limiteFundo?: LimitePagamentoEcgTerceiro = null;
  dataReferenciaDefault: Date;
  ocorrencias: OcorrenciaValidacaoVO[] = [];

  constructor(
    protected injector: Injector,
    private limiteService: LimitePagamentoEcgTerceiroService,
    private tipoPagamentoEcgTerceiroService: TipoPagamentoEcgTerceiroService,
    private loadingService: BnLoadingService,
    private dataSistemaService: DataSistemaService,
    private alertsService: BnAlertsService,
    formBuilder: FormBuilder
  ) {
    super(limiteService);
    this.formGroup = formBuilder.group({
      ideTipoPagamentoEcgTerceiro: [null, Validators.required],
      valorLimiteAnterior: [null],
      dataReferencia: [null, Validators.required],
      valorLimiteTotal: [null, Validators.required],
      comentarios: [null, Validators.required],
    });

    this.formGroup.get("valorLimiteAnterior").disable();
    this.formGroup
      .get("ideTipoPagamentoEcgTerceiro")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((ideTipoPagamentoEcgTerceiro) => {
        if (
          Number(ideTipoPagamentoEcgTerceiro) != this.ideTipoSelecionado &&
          ideTipoPagamentoEcgTerceiro != null &&
          ideTipoPagamentoEcgTerceiro != "null"
        ) {
          this.ideTipoSelecionado = Number(ideTipoPagamentoEcgTerceiro);
          this.buscarPorTipo(ideTipoPagamentoEcgTerceiro);
        }
      });

    this.atualizaStatusCamposEdicao();
  }

  ngOnInit(): void {
    this.carregarTipos();
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  async buscarPorTipo(ideTipoPagamentoEcgTerceiro: number) {
    try {
      this.loadingService.bloqueiaTela();
      const dataCorrente = await this.dataSistemaService
        .getDataCorrente()
        .toPromise();
      this.dataReferenciaDefault = moment(dataCorrente)
        .subtract(1, "month")
        .endOf("month")
        .toDate();
      const ultimoLimite = await this.limiteService.buscarPorIdeTipo(
        ideTipoPagamentoEcgTerceiro
      );
      this.atribuiModel(ultimoLimite);
      this.limiteFundo = ultimoLimite;
      this.limiteFundoPrevio = new LimitePagamentoEcgTerceiro();
      this.limiteFundoPrevio.valorLimiteTotal =
        this.limiteFundo.valorLimiteAnterior;
      if (this.limiteFundo.id == null) {
        this.modoEdicao = true;
      } else {
        this.modoEdicao = false;
      }
      this.atualizaStatusCamposEdicao();
      this.atualizaFormComModel();
    } catch (err) {
      console.log("Houve um erro ao carregar por tipo", err);
    } finally {
      this.loadingService.liberaTela();
    }
  }

  atualizaFormComModel() {
    const dataReferencia = this.limiteFundo?.dataReferencia
      ? moment(this.limiteFundo?.dataReferencia).utcOffset(0)
      : this.dataReferenciaDefault;
    this.formGroup.patchValue({
      valorLimiteAnterior: this.limiteFundoPrevio?.valorLimiteTotal | 0,
      dataReferencia: dataReferencia,
      valorLimiteTotal: this.limiteFundo?.valorLimiteTotal,
      comentarios: this.limiteFundo?.comentarios,
    });
  }

  get temTipoLimiteSelecionado() {
    return this.formGroup.get("ideTipoPagamentoEcgTerceiro").value != null;
  }

  get naoTemTipoLimiteSelecionado() {
    return !this.temTipoLimiteSelecionado;
  }

  private atribuiModel(model: LimitePagamentoEcgTerceiro) {
    super.setModel(model);
  }

  async carregarTipos() {
    this.tipos = await this.tipoPagamentoEcgTerceiroService
      .listarTodos()
      .toPromise();
    this.formGroup.get("ideTipoPagamentoEcgTerceiro").enable();
  }

  novoCadastro() {
    this.limiteFundoPrevio = this.limiteFundo;
    this.limiteFundo = null;

    let dataReferenciaSugerida = this.dataReferenciaDefault;
    if (
      !moment(this.limiteFundoPrevio?.dataReferencia).isBefore(
        moment(dataReferenciaSugerida)
      )
    ) {
      dataReferenciaSugerida = moment(this.limiteFundoPrevio?.dataReferencia)
        .add(1, "days")
        .toDate();
    }

    this.atualizaFormComModel();
    this.toggleModoEdicao();
  }

  corrigirLimite() {
    this.toggleModoEdicao();
  }

  toggleModoEdicao() {
    this.modoEdicao = !this.modoEdicao;

    this.atualizaStatusCamposEdicao();
  }

  atualizaStatusCamposEdicao() {
    if (this.modoEdicao) {
      this.formGroup.get("ideTipoPagamentoEcgTerceiro").enable();
      this.formGroup.get("dataReferencia").enable();
      this.formGroup.get("valorLimiteTotal").enable();
      this.formGroup.get("comentarios").enable();
    } else {
      this.formGroup.get("ideTipoPagamentoEcgTerceiro").disable();
      this.formGroup.get("dataReferencia").disable();
      this.formGroup.get("valorLimiteTotal").disable();
      this.formGroup.get("comentarios").disable();
    }
    this.formGroup.get("valorLimiteAnterior").disable();
  }

  cancelarEdicao() {
    this.modoEdicao = false;
    this.limiteFundo = this.model;
    this.limiteFundoPrevio = new LimitePagamentoEcgTerceiro();
    this.limiteFundoPrevio.valorLimiteTotal =
      this.limiteFundo.valorLimiteAnterior;

    this.atualizaFormComModel();
    this.atualizaStatusCamposEdicao();
  }

  async salvar() {
    try {
      if (this.formGroup.invalid) {
        this.formGroup.markAllAsTouched();
        return;
      }
      this.loadingService.bloqueiaTela();
      this.ocorrencias = [];
      const {
        ideTipoPagamentoEcgTerceiro,
        dataReferencia,
        valorLimiteTotal,
        comentarios,
      } = this.formGroup.value;
      const dataReferenciaTratada = moment(dataReferencia)
        .utcOffset(-3)
        .set({ hours: 0, minutes: 0 })
        .toDate();

      const entrada: EntradaLimitePagamentoEcgTerceiro = {
        ideTipoPagamentoEcgTerceiro,
        dataReferencia: dataReferenciaTratada,
        valorLimiteTotal,
        comentarios,
        id: this.limiteFundo?.id,
      };
      await this.limiteService.salvar(entrada);
      this.alertsService.alertaSucesso("Sucesso", "Salvo com Sucesso!");
      this.router.navigate(["limite-pagamento-ecg-por-terceiros", "pesquisa"]);
      this.loadingService.liberaTela();
    } catch (err) {
      this.trataErros(err);
    }
  }

  private trataErros(error) {
    console.log(error);
    this.ocorrencias = this.limiteService.ocorrencias;
    this.loadingService.liberaTela();
  }
}
